// API URL'leri — bozuk değerleri (https://https://..., çift slash) temizle
const normalizeUrl = (raw, fallback) => {
  let url = (raw || fallback || '').trim();
  if (!url) return fallback;

  // https://https://host  -> https://host
  url = url.replace(/^(https?:\/\/)+/i, (match) => {
    const isHttps = /https/i.test(match);
    return isHttps ? 'https://' : 'http://';
  });

  // protokol sonrası çift slash'leri düzelt (path’teki //api -> /api)
  url = url.replace(/([^:]\/)\/+/g, '$1');

  return url;
};

export const API_URL = normalizeUrl(
  process.env.REACT_APP_API_URL,
  'https://appgateway.odazen.com/api/'
);
export const API_BASE = normalizeUrl(
  process.env.REACT_APP_API_BASE,
  'https://appgateway.odazen.com/chathub'
);
// Asıl (kanonik) alan adı: canonical, og:url, JSON-LD ve site haritası bunu kullanır. www → odazen.com
// yönlendirmesi sunucuda yapılır; derleme ortamındaki REACT_APP_WEBSITE_URL (eski www değeri) bunu ezmesin diye sabit.
export const SITE_URL = 'https://odazen.com';
// Backend JwtMiddleware x-root ile birebir aynı olmalı (AuthorizeKeys)
export const API_KEY =
  process.env.REACT_APP_API_KEY || 'mTYrXNqFtKBG3839MhqsmEoIm8gW';
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '107267288861-fl5dqbl2qj8gavv8vdhreih2pm9eoq2n.apps.googleusercontent.com';
export const FACEBOOK_APP_ID =
  process.env.REACT_APP_FACEBOOK_APP_ID || '2072803373648458';
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  'AIzaSyD6sixG9GlsHy_Vu5K8VGLhhj4sPLSLMPw';

// Diğer config değerleri
export const CONFIG = {
  channelId: '1',
  defaultLanguage: 'tr',
};

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.info('[Odazen] API_URL =', API_URL);
}
